export default "__VITE_ASSET__Co_4v4ID__"